import {
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { GeneralService } from '../../../../services/general/general.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['../../../../../shared-styles/classes.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IndexComponent implements OnInit {

  public loading: any = false;
  public invoiceData: any;
  private invoiceId: any;
  private type:any;

  constructor(
    public general: GeneralService,  
    private route:ActivatedRoute,
  ) {
   // this.isMobile = this.general.isMobile();  
  }

  async ngOnInit() {

    try {
      this.invoiceId = this.route.snapshot.paramMap.get('id');
      this.type = this.route.snapshot.paramMap.get('type');
      console.log("Invoice id", this.invoiceId);
      console.log("Invoice type", this.type);
      
      await this.general.setLoading(true);      
      await  this.getInvoiceInfo();
      
      //console.log(this.classId);
      
    } catch (error) {
      console.log(error);
      
    } finally {
      
      await this.general.setLoading(false);
      
    }  
  }



  async getInvoiceInfo() {
    try {
      console.log("funcion getinvoice data");
      await this.general.setLoading(true);
      const response = await this.general.httpPost(
        'teacher-detail-wallet-info',
        {         
          transaction_id:this.invoiceId,
          transaction_type: this.type
        }
      );
     this.invoiceData = response.message;
       
         console.log(this.invoiceData);

          
     
    } catch (error) {
      console.log(error);
    }
  }
}
